import { defineStore } from "pinia";
import { ref } from "vue";

import type { VERIFICATION_DATA } from "./verification.types";

export const useVerificationStore = defineStore("verification", () => {
    const verificationData = ref<VERIFICATION_DATA | null>(null);

    const restoreToDefault = () => {
        verificationData.value = null;
    };

    return {
        verificationData,
        restoreToDefault,
    };
});
